export default "86524d727c834c7b.svg"